var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('youtube',{ref:"youtubePlayer",attrs:{"resize":"","fitParent":"","video-id":_vm.getId,"player-vars":_vm.playerVars}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }